// eslint-disable-next-line jsx-a11y/anchor-is-valid
import React, { useState } from 'react';
import { Card, Button, Accordion, Row, Col, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export default function BakeryFoundation() {
    const navigate = useNavigate();
    const [quantity, setQuantity] = useState(1);

    const navigateToCourses = () => {
        navigate('/contactus');
    }
    const courseDetails = {
        name: "Bakery Foundation Course",
        // price: "Rs. 4000.00",
        // date: "04 February 2025",
        timing: "10:00 am to 5:00 pm",
        ageCriteria: "13 years & Above",
        whatsappNumber: "9445744663"
    }

    const handleBookNow = () => {
        const message = `Course Name: ${courseDetails.name}%0ATiming: ${courseDetails.timing}%0AQuantity: ${quantity}`;
        const whatsappUrl = `https://wa.me/${courseDetails.whatsappNumber}?text=${message}`;
        window.open(whatsappUrl, "_blank");
    };

    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Foundation Course</h1>
                </div>
            </div>
            <div className='diplomaPge'>
                <section>
                    <div className="header-section" style={{ fontFamily: 'DancingScript,cursive' }}>
                        <h1 style={{ fontSize: '28px' }}>Bakery Foundation Course</h1>
                    </div>
                </section>

                <Row style={{ margin: '0', padding: '0' }}>
                    <Col md={8} style={{ paddingLeft: "5%", lineHeight: '2.5' }}>

                        {/* Header Section */}
                        <section className="about-course" >
                            <h2>About Course</h2>
                            <p style={{ textAlign: 'justify' }}>Step into the world of baking with our 5-Day Bakery Foundation Course at Finesse Academy for Bakery & Pastry Arts! Whether you're a passionate home baker or an aspiring pastry chef, this hands-on program will equip you with essential techniques and expert tips. 
Learn expert baking techniques, ingredient functions, professional finishing, and presentation skills—all in just 5 days!
Join us and turn your baking dreams into reality! Limited seats available—enroll now!</p>
                        </section>

                        <section className="learn-section" >
                            <h2>What Will You Learn?</h2>
                            <ul>
                                <li><strong>Breads & Muffins:</strong>  Soft bread rolls, Korean cheese buns, doughnuts, vanilla muffins, chocolate muffins. </li>
                                <li> <strong>Cookies & Cupcakes: </strong>Vanilla cupcakes, chocolate cupcakes, chocolate Chantilly, white chocolate Chantilly, chocochip cookies, Danish butter cookies, cassack cookies.  </li>
                                <li><strong>Pastries & Tarts:</strong>  Eclairs, choux buns, craquelin, vanilla diplomat cream, vanilla sable, chocolate sable, chocolate custard tart, lemon tart, shortcrust pastry, chicken quiche.  </li>
                                <li><strong>Desserts & Mousse:</strong> Understand how to develop a creative yetCreme caramel, creme brulee, panna cotta, chocolate mousse, caramel mousse, brownies, lemon cake.  </li>
                                <li><strong>Creams & Finishing Touches:</strong>  Soft caramel sauce, Italian meringue buttercream, chocolate ganache, caramel cake, chocolate trifle cake. </li>
                            </ul>
                        </section>

                        {/* <section style={{ fontFamily: 'Roboto' }}>
                            <h2>Who Should Enroll?</h2>
                            <p>This diploma is ideal for individuals who want to pursue a professional career in the bakery and pastry arts. Whether you are a beginner with a passion for baking or a culinary professional seeking to expand your expertise, this course offers the perfect balance of theory and hands-on practice.
                            </p>
                        </section> */}
                        {/* What Will You Learn Section */}
                        <section className="learn-section">
                           
                                
                            
                        </section>

                        


                        {/* Course Curriculum Section */}
                        
                    </Col>
                    <Col md={4}>
                        {/* Sidebar Section */}
                        <div className="course-sidebar">
                            <Card className="sidebar-card">
                                <Card.Body>
                                    {/* YouTube Video */}
                                    <div className="video-container">
                                        <img src='images/prof.jpg' style={{ width: '100%' }} />
                                    </div>

                                    {/* Pricing */}
                                    <p className="course-price">₹ 18,000<br />
                                        <span className='course-amt'>  (Inclusive of 18% GST)</span></p>

                                    {/* <button onClick={navigateToCourses} className="add-to-cart">Enrol Now</button> */}
                                    {/* <Button variant="outline-primary" className="buy-course" block>Buy Course</Button> */}

                                    {/* <hr className="course-divider" /> */}
                                    &nbsp;
                                    {/* Course Details */}
                                    <ul 
                                    className="course-includes"
                                    >
                                        <p><strong>Duration:</strong></p>
                                        <p  className="age">5 Days</p>
                                        <p><strong>Age Criteria:</strong> </p>
                                        <p className="age">{courseDetails.ageCriteria}</p>
                                        <p><strong>Timing:</strong></p>
                                        <p className="timing"> {courseDetails.timing}</p>
                                        
                                       

                                        <Form.Group>
                                            <Form.Label><strong>Quantity</strong></Form.Label>
                                            <div className="quantity-controls">
                                                <button onClick={() => setQuantity(quantity > 1 ? quantity - 1 : 1)} className="quantity-btn">
                                                    −
                                                </button>
                                                <span className="quantity-display">{quantity}</span>
                                                <button onClick={() => setQuantity(quantity + 1)} className="quantity-btn">
                                                    +
                                                </button>
                                            </div>
                                        </Form.Group>

                                        <button className="add-to-cart" onClick={handleBookNow} style={{background:'black'}}>
                                            Book Now
                                        </button>
                                        {/* <li><strong>Duration:</strong> 2 months</li>
                                        <li><strong>Schedule: </strong> 5 days a week</li>
                                        <li><strong>Timing: </strong> 10.00 am-5.00 pm</li>
                                       
                                        <li><strong>Certificate:</strong> Yes</li> */}
                                    </ul>
                                    {/* <Button  className="share-course">Share this course</Button> */}
                                </Card.Body>

                            </Card>
                        </div>
                    </Col>
                </Row>
                {/* About Course Section */}
            </div>

        </>
    )
}